import {settleExistingSection} from '../../core/actionHighlighter';

/**
 * Open License Management on Canvas Settings.
 *
 * One level, not two. The tab holds License Details and Feature Licenses
 * as plain bold headings inside bordered panels - checked in the rendered
 * page, where neither is an accordion and no control answers to either
 * name. Selecting the tab is the whole of opening this section.
 *
 * Settled rather than clicked once, for the same reason as Users: this
 * runs the moment the page is navigated to, when the tabs are often not
 * in the DOM yet, and the Upload License form opens inside this tab.
 *
 * @return {Promise<void>} completion
 */
export async function openLicensesSection() {
	try {
		return await settleExistingSection('License Management');
	} catch (_) {
		throw new Error('license_section_unavailable');
	}
}
